/* eslint-disable no-unused-expressions */
import React from 'react';
import {
  Dialog,
  Container,
  DialogTitle,
  CancelButton,
  SubmitButton,
  DialogActions,
  DialogContent,
  ActionsContainer,
  DialogContentText,
  Typography,
} from './styles';

function LogoutDialog({ onSuccess, onCancel, ...props }) {
  return (
    <Container>
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        {...props}
      >
        <DialogTitle id="alert-dialog-title" disableTypography>
          <Typography variant="h6">Sair</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            Você tem certeza que deseja sair do sistema?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ActionsContainer>
            <CancelButton
              onClick={() => {
                onCancel?.();
              }}
              type="button"
              variant="contained"
              color="primary"
            >
              Cancelar
            </CancelButton>
            <SubmitButton
              onClick={() => {
                onSuccess?.();
              }}
              variant="contained"
              color="primary"
            >
              Sair
            </SubmitButton>
          </ActionsContainer>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default LogoutDialog;
